<template>
  <div
    class="aiBox homeWrap wow animate__animated animate__fadeIn"
    @click="navTo('/product/ai')"
  >
    <div class="title" style="text-align: center">
      <div class="text1">AI产品</div>
      <div class="text2">实验室安全，AI “智” 在必得</div>
    </div>
    <div class="subTitle">
      <div>实时监控无死角</div>
      <div class="line"></div>
      <div>风险预警秒响应</div>
      <div class="line"></div>
      <div>让每一次实验都安心启航</div>
    </div>
    <div class="aiList mainBox">
      <div class="aiItem maria">
        <OssImg src="/UIV3/aiIcon.png" alt="" class="aiIcon" />
        <div class="aiItemTitle">智能体</div>
        <div class="aiItemText">
          智能巡检预警隐患、管理危废全流程、调度应急、监管行为，还能分析数据辅助决策
        </div>
      </div>
      <div class="aiItem maria">
        <OssImg src="/UIV3/aiIcon.png" alt="" class="aiIcon" />
        <div class="aiItemTitle">AI智慧问答</div>
        <div class="aiItemText">
          快速解答危废处置流程、安全检查标准、设备操作规范等常见问题，精准解析复杂提问
        </div>
      </div>
      <div class="aiItem maria">
        <OssImg src="/UIV3/aiIcon.png" alt="" class="aiIcon" />
        <div class="aiItemTitle">行为算法</div>
        <div class="aiItemText">
          精准识别违规行为，发现异常立即发出警报，有效降低人为失误引发的安全风险，提升实验室安全管理效率 。
        </div>
      </div>
    </div>
    <!-- <div class="aiProduct mainBox">
      <OssImg src="images/home2.png" alt="" class="mariaNoShadow" />
      <div class="aiProductText">
        <div>5合1融合，集成人、物、行为、事件、AIOP，5大类多种算法于一体</div>
        <div>
          设备内置1-8个GPU（物理引擎），1个GPU=4个vGPU,虚拟引擎不影响物
          理引擎性能，但是可以加载更多算法,实现2秒内完成数据的采集和分
        </div>
      </div>
    </div> -->
  </div>
</template>

<script lang="ts" setup>
import {} from "vue";
import { navTo } from "@/utils/util";
</script>

<style lang="scss" scoped>
.aiBox {
  width: 100vw;
  padding: 0 0 1.5rem 0;
  margin-top: 2rem;
  background: #ebf1fb url("@/assets/images/bg/aiBg.png") no-repeat;
  background-size: 100% 100%;

  .title {
    margin: 2rem 0 0;
  }

  .subTitle {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 1.25rem;
    color: #424242;
    margin-bottom: 1.5rem;
    .line {
      width: 1px;
      height: 16px;
      background: #424242;
      border-radius: 99px 99px 99px 99px;
      margin: 0 1rem;
    }
  }

  .aiProduct {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 60% !important;
      margin-right: 1.5rem;
    }

    .aiProductText {
      width: 36%;
      font-size: 1.25rem;
      color: #fff;
      line-height: 1.75rem;
      text-align: justify;
      padding: 1rem;
      background: #1a4078;
      border-radius: 1rem;
      text-indent: 2ch;
    }
  }
}

.aiList {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;

  .aiItem {
    width: 28.9375rem;
    height: 14.0625rem;
    background: url("@/assets/images/bg/aiBg2.png") no-repeat;

    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 1rem;

    .aiIcon {
      width: 3rem;
      height: 3rem;
      margin-bottom: 1rem;
    }

    .aiItemTitle {
      font-weight: 500;
      font-size: 1rem;
      color: #212121;
      margin-bottom: 0.5rem;
      display: flex;
      align-items: center;

      &::before {
        content: "";
        display: inline-block;
        width: 3px;
        height: 16px;
        background: #32a89e;
        border-radius: 99px;
        margin-right: 6px;
        filter: blur(0.3px);
      }
    }

    .aiItemText {
      font-weight: 500;
      font-size: 0.875rem;
      color: #888888;
      text-indent: 2rem;
    }
  }
}

// @media(max-width: 768px) {
//   .aiBox {
//     margin-top: 0 !important;
//   }

//   .aiProduct {
//     flex-direction: column;

//     img {
//       width: 100% !important;
//       margin-right: 0 !important;
//     }

//     .aiProductText {
//       width: 100% !important;
//     }
//   }
// }
</style>
